var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageSeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.232 1.39a.625.625 0 0 0-.464 0l-7.46 2.985 3.005 1.202L13.005 2.5l-2.773-1.11zm4.456 1.783L6.995 6.25 10 7.452l7.692-3.077-3.005-1.202zm4.062 2.125-8.125 3.25v9.904l8.125-3.25V5.298zM9.375 18.452V8.548L1.25 5.298v9.904l8.125 3.25zM9.304.23a1.875 1.875 0 0 1 1.392 0l8.911 3.565a.625.625 0 0 1 .393.58v10.827c0 .51-.311.97-.786 1.16l-8.982 3.593a.625.625 0 0 1-.464 0L.786 16.362A1.25 1.25 0 0 1 0 15.202V4.375c0-.256.156-.485.393-.58L9.303.23z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageSeam);
export default __webpack_public_path__ + "static/media/package-seam.66feb03b28f2982d94985e22733cce56.svg";
export { ForwardRef as ReactComponent };